module.exports = __webpack_public_path__ + "static/media/avatar4.23a5577b.png";